import { Radio } from '@material-ui/core';
import SearchComponent from 'components/SearchComponent';
import styled, { css } from 'styled-components';
import { GutterCSS } from 'styles/common';

import { getColorFromKey } from 'constants/helper';

export const HeaderListItem = styled.div`
  padding: 0.75rem;
`;

const boxShadowCSS = css`
  box-shadow:
    0 1px 2px 0 rgba(60, 64, 67, 0.302),
    0 2px 6px 2px rgba(60, 64, 67, 0.149);
  outline: 0;
`;

const hoverCSS = css`
  ${boxShadowCSS};
  z-index: 0;
`;

const editingCSS = css`
  ${boxShadowCSS};
  z-index: 3;
  background: ${(props) => props.theme.palette.background.default};
`;

export const ListItem = styled.div`
  padding: 0.5rem 0.25rem 0.5rem 0.25rem;
  position: relative;
  ${(props) =>
    props.isAddNewItem &&
    props.onClick &&
    css`
      cursor: pointer;
    `}

  ${(props) =>
    !props.isEditing &&
    css`
      &:hover {
        ${hoverCSS};
      }
    `}
  ${(props) => props.isEditing && editingCSS};

  border-bottom: ${(props) =>
    props.isEditing ? `2px solid ${props.theme.palette.primary.main}` : `1px solid ${props.theme.palette.divider}`};
`;

export const FirstRow = styled.div`
  display: flex;
  cursor: pointer;
  align-items: flex-start;
`;

export const SecondRow = styled.div`
  padding-left: 33px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  margin-bottom: 0.25rem;
  cursor: auto;
`;

export const TaskStatsContainer = styled.div`
  display: flex;
  align-items: center;
  & > * {
    margin-right: 0.25rem;
  }
  cursor: auto;
`;

export const TextContainer = styled.div`
  width: 100%;
  min-height: 18px;
  position: relative;
  margin-right: 30px;
`;

export const IconContainer = styled.div`
  padding: 0 8px 0 4px;
  width: 32px;
  height: auto;
  // padding-top: 2px;
  & > * {
    padding: 0;
  }
`;

export const TeamNameTextContainer = styled.div`
  display: inline-flex;
  // max-width: calc(50% - 86px);
  max-width: 40%;
  align-items: center;
  display: flex;
  // height: 30px;
  ${GutterCSS};
  color: #777;
  // margin-left: 0.5rem;
`;

export const ThirdRow = styled.div`
  padding-left: 33px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 0.5rem;
  cursor: auto;
  & > :first-child {
    flex-basis: 27%;
  }
  & > :nth-child(2) {
    flex-basis: 39%;
    // text-align: center !important;
    justify-content: center !important;
  }
  & > :nth-child(3) {
    flex-basis: 33%;
    justify-content: flex-end !important;
  }
`;

export const DueDateContainer = styled.div`
  display: inline-flex;
  background: ${(props) => props.theme.palette.background.default};
  border: 1px solid ${(props) => props.theme.palette.divider};
  padding: 0 0.32rem;
  border-radius: 4px;
  align-items: center;
  height: 30px;
  &:hover {
    cursor: pointer;
    ${hoverCSS};
    // svg {
    //   fill: ${(props) => props.theme.palette.primary.main};
    // }
  }
  ${GutterCSS};
  ${(props) =>
    props.disabled &&
    css`
      cursor: initial;
      opacity: 0.65;
      pointer-events: none;
    `}
`;

export const CheckRadio = styled(Radio)`
  &.MuiRadio-root:hover {
    background-color: transparent;
    svg {
      fill: ${(props) =>
        props.hoverColor ? getColorFromKey(props.hoverColor) : getColorFromKey('textSecondary')} !important;
    }
    // &.Mui-checked {
    svg {
      fill: ${(props) => (props.color ? getColorFromKey(props.color) : getColorFromKey('green'))};
    }
  }
  &.MuiRadio-root.Mui-checked:hover {
    background-color: transparent;
    svg {
      fill: ${(props) => getColorFromKey('textSecondary')};
    }
  }
  ${GutterCSS};
`;

export const SubObjectiveSearch = styled(SearchComponent)`
  height: 30px;
  min-height: 30px;
  width: 42%;
  ${GutterCSS};
  .react-select-custom__placeholder {
    font-size: ${(props) => props.theme.typography.caption.fontSize};
  }
  .react-select-custom__control {
    height: 30px;
    min-height: 30px;
    background-color: transparent;
    border: 0;
    // border: 2px solid ${(props) => props.theme.palette.borders.lightGrey};
    border-radius: 4px;
    // padding-left: 0.25rem;
    // padding-right: 0.25rem;
    padding: 0;
  }
  .react-select-custom__value-container {
    padding: 0;
  }
  .react-select-custom__placeholder {
    transform: translateY(-55%);
    margin-left: 1.25rem; // because we are displaying goal icon on the left
  }
  .react-select-custom__single-value {
    margin-left: 1.25rem;
  }
  .react-select-custom__menu {
    max-width: 135%;
    min-width: 135%;
    ${(props) =>
      props.wide &&
      css`
        max-width: 225%;
      `}
  }
  .react-select-custom__option {
    white-space: normal !important;
  }
`;

export const GoalContainer = styled.div`
  display: inline-flex;
  max-width: 40%;
  align-items: center;
  ${GutterCSS};
`;
